var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "berg-icons-tick",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_5506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8063 12C6.50209 12 6.21396 11.884 6.02933 11.684L3.53057 8.986C3.45332 8.90268 3.39692 8.80774 3.36459 8.70659C3.33227 8.60545 3.32466 8.50009 3.3422 8.39654C3.35973 8.29299 3.40207 8.19329 3.4668 8.10312C3.53152 8.01295 3.61735 7.93409 3.7194 7.87104C3.8214 7.80774 3.93769 7.7615 4.0616 7.73499C4.18552 7.70848 4.31461 7.70221 4.4415 7.71654C4.56838 7.73088 4.69055 7.76553 4.80101 7.81852C4.91148 7.87151 5.00806 7.9418 5.08522 8.02534L6.72938 9.79922L10.8632 4.37472C11.0003 4.19561 11.2187 4.06826 11.4706 4.02058C11.7224 3.97291 11.9871 4.00881 12.2066 4.12041C12.6633 4.35243 12.8039 4.8439 12.5186 5.21765L7.63433 11.624C7.55095 11.7338 7.43603 11.8254 7.29953 11.8907C7.16304 11.956 7.00909 11.9932 6.85106 11.9989C6.83568 12 6.82169 12 6.8063 12Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_5506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.92,
    height: 8.32,
    fill: "white",
    transform: "translate(3.04004 3.83997)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.309cc4657cca8ec0a67d43480ae1590f.svg";
export { ForwardRef as ReactComponent };